<div class="row" style="justify-content: center">
  <h1 class="text-center" mat-dialog-title>Seleccionar Colaborador</h1>
</div>
<div class="containerModal">
  <form [formGroup]="Colaboradores" mat-dialog-content>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <select class="custom-select form-control" formControlName="colaborador" (ngModelChange)="applyFilter($event)">
          <option value="">Todos</option>
          <option *ngFor="let colaborador of colaboradores;let i = index;" [ngValue]="{ colaborador: colaborador, nif: nifColaborador[i], codigo: codigoColaborador[i] }">{{colaborador}}</option>
        </select>        
      </div>
    </div>
  </form>
  <div mat-dialog-actions>
    <button mat-button class="btn-block btn-secondary" (click)="onNoClick()">Cancelar</button>
  </div>
</div>
